import React from 'react';
import Icon from '../../Icon';
import { useNavigate } from 'react-router-dom';
import { remove as removeAddress } from '../../../Actions/Address.action';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { add } from 'lodash';

const AddressListItemDesktop = ({ address }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  /*
   * Non editable addresses are updated in NAV
   */
  const editable = () => {
    return (
      address &&
      !(address.customData && address.customData.shipToCode) &&
      !address.addressType?.toLowerCase().includes('billing')
    );
  };

  return (
    <div
      className={clsx(
        'grid',
        'grid-cols-6',
        'items-center',
        'px-2',
        'gap-4'
      )}
    >
      <p
        className={clsx(
          'text-sm',
          'text-ellipsis',
          'overflow-hidden',
          'whitespace-nowrap'
        )}
        title={address.customData.shipToName}
      >
        {address.customData.shipToName}
      </p>
      <p
        className={clsx(
          'text-sm',
          'text-ellipsis',
          'overflow-hidden',
          'whitespace-nowrap'
        )}
        title={address.address}
      >
        {address.address}
      </p>
      <p
        className={clsx(
          'text-sm',
          'text-ellipsis',
          'overflow-hidden',
          'whitespace-nowrap'
        )}
        title={address.zipCode}
      >
        {address.zipCode}
      </p>
      <p
        className={clsx(
          'text-sm',
          'text-ellipsis',
          'overflow-hidden',
          'whitespace-nowrap'
        )}
        title={address.city}
      >
        {address.city}
      </p>
      <p
        className={clsx(
          'text-sm',
          'text-ellipsis',
          'overflow-hidden',
          'whitespace-nowrap'
        )}
        title={address.addressType}
      >
        {address.addressType}
      </p>
      <span className="flex h-11 justify-end lg:gap-2">
        {editable() && (
          <>
            <button
              className={clsx('btn', 'btn--clear', 'btn--small')}
              onClick={() => navigate(`edit/${address.systemId}`)}
            >
              <Icon
                name="edit"
                className="color-primary"
                style={{
                  width: '24px',
                  height: '24px',
                }}
              />
            </button>
            <button
              className={clsx(
                'btn',
                'btn--clear',
                'btn--small',
                'text-error-500'
              )}
              onClick={() => dispatch(removeAddress(address.systemId))}
            >
              <Icon
                name="delete"
                style={{
                  width: '24px',
                  height: '24px',
                }}
              />
            </button>
          </>
        )}
      </span>
    </div>
  );
};
export default AddressListItemDesktop;
